export const withForceAbort = async <T>(abortSignal: AbortSignal, promise: Promise<T>) => {
  abortSignal.throwIfAborted()
  const abortPromise = Promise.withResolvers<T>()
  const listener = () => {
    try {
      abortSignal.throwIfAborted()
    } catch (e) {
      abortPromise.reject(e)
    }
  }
  abortSignal.addEventListener('abort', listener, { once: true })

  promise
    .then(val => {
      abortPromise.resolve(val)
      abortSignal.removeEventListener('abort', listener)
    })
    .catch(e => {
      abortPromise.reject(e)
      abortSignal.removeEventListener('abort', listener)
    })

  return Promise.race([promise, abortPromise.promise])
}
